module.exports = __webpack_public_path__ + "img/dashboard.3db2bb8a.svg";